export default "__VITE_ASSET__Bc9zYx5X__"